import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { BancariaService } from "../../service/BancariaService";
import { Bancaria } from "../../models/Bancaria";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { GenericComponent } from "../../components/GenericComponent";
import { BancariaBVG } from "../../models/cpn/BancariaBVG";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Column } from "primereact/column";
import { TablaDinamica } from "../../components/TablaDinamica";
import { useLazyParams } from "../../hooks/useLazyParams";

export const ReferenciaBancaria = ({ tipo, id, toast, permss, bvg, num = 8, tipoFrmEmpresa = null, soloLectura }) => {

    const generic = new GenericComponent();
    const omodel = bvg === true ? new BancariaBVG() : new Bancaria({ tipoFrmEmpresa, tipo });
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const referenciaService = new BancariaService();
    const [dialogReferencia, setDialogReferencia] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [catalogo, setCatalogo] = useState(null);
    const [load, setLoad] = useState(false);
    const menuRef = useRef(null);
    const tablaBancaria = useLazyParams({ modelo: omodel.model });
    const { inText, inDrop } = InputComponent({ registers: tablaBancaria.data, omodel, generic, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyBancaria();
        // eslint-disable-next-line
    }, [tablaBancaria.lazyParams, id]);

    const loadLazyBancaria = () => {
        tablaBancaria.setLoading(true);
        const _params = { ...tablaBancaria.lazyParams, idp: id, tipo: tipo, tipoFrmEmpresa: tipoFrmEmpresa };
        referenciaService.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaBancaria.setTotalRecords(res.data.total);
            tablaBancaria.setData(res.data.registros);
        }).finally(() => tablaBancaria.setLoading(false));
    }

    const editBancaria = (data) => {
        const iniciar = catalogo == null ? (bvg !== null && bvg !== undefined ? 2 : 1) : 0;
        referenciaService.consultarBancaria(data?.id, iniciar).then(res => {
            if (iniciar === 1 || iniciar === 2) {
                setCatalogo(res.data.tipo);
            }
            const _ref = res.data.referencia;

            reset(_ref);
            setDialogReferencia(true);
        });
    }

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        data.tipoFrmEmpresa = tipoFrmEmpresa;
        setLoad(true);

        const request = getValues('id') == null ? referenciaService.newBancaria(data) : referenciaService.editarBancaria(data);
        request.then(res => {
            setDialogReferencia(false);
            loadLazyBancaria();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setLoad(false);
        });
    }

    const openNew = () => {
        if (catalogo == null) {
            referenciaService.newBancaria({ iniciar: bvg !== null && bvg !== undefined ? 2 : 1 }).then(res => {
                setCatalogo(res.data);
                reset(defaultValues);
                setDialogReferencia(true);
            });
        }
        else {
            reset(defaultValues);
            setDialogReferencia(true);
        }
    }

    const confirmDelete = (data) => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteBancaria(data?.id)
        });
    };

    const deleteBancaria = (idReg) => {
        referenciaService.deleteBancaria(idReg).then(res => {
            loadLazyBancaria();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editBancaria(registroSeleccionado) }] }];
        }

        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editBancaria(registroSeleccionado) });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado) });

        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => (
        <Button
            icon="pi pi-caret-down"
            type="button"
            className="p-button-rounded p-button-success mr-2"
            title="Opciones/Acciones"
            aria-controls="popup_menu_bancaria"
            aria-haspopup
            onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-rounded p-button-success" type="button" onClick={openNew} title="Registrar información" />
            )}
            <span className="font-bold">{num}.- Referencia Bancaria:</span>
        </div>
    );

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor complete los campos requeridos', life: 3000 });
    }

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_bancaria" />
            <TablaDinamica
                modelo={omodel.model}
                estadoTabla={tablaBancaria}
                datos={tablaBancaria.data}
                totalRegistros={tablaBancaria.totalRecords}
                dataKey="id"
                acciones={ColumnaAcciones}
                header={cabeceraTabla()}
            />

            {!['FRM_TOYOTA', 'FRM_DIFARE'].includes(tipoFrmEmpresa) && (
                <span style={{ fontSize: '10px' }}><b>Nota:</b> Adjunte el estado de cuenta digital o cartilla, correspondiente a los movimientos del último mes previo a la DDC.</span>
            )}

            <Dialog visible={dialogReferencia} header={soloLectura ? "Ver Referencia" : (getValues('id') == null ? "Nueva Referencia" : "Editar Referencia")} modal className="p-fluid modal-ssize"
                onHide={e => setDialogReferencia(false)} style={{ width: '400px' }}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit, onError)(e); }}>
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-building-columns text-primary"></i>
                                REFERENCIA BANCARIA
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>
                    <div className="formgrid grid">
                        {inText('institucion_financiera', { icon: 'pi pi-building-columns' }, 12)}
                        {inDrop('tipo_cuenta', catalogo, { lab: omodel.optionLabel }, 12)}
                        {(!['FRM_DIFARE', 'FRM_TOYOTA'].includes(tipoFrmEmpresa) || tipo === 'clientePn') && inText('numero_cuenta', {}, 12)}
                    </div>

                    {soloLectura ? (
                        <div className="flex justify-content-end mt-3">
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={() => setDialogReferencia(false)} />
                        </div>
                    ) : (
                        generic.buttonsForms(setDialogReferencia, load)
                    )}
                </form>
            </Dialog>
        </>
    );
}
